import { Images } from "assets";
import { Svg } from "assets/svg";
import { Colors } from "colors";
import Buttons from "components/Buttons";
import VText from "components/VText";
import React from "react";
import { View, Text, TouchableOpacity, Image, StyleSheet } from "react-native";
import Carousel from "react-native-reanimated-carousel";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import FavdislikeCardComponent from "./favdislikeCardComponent";
import { useLocalSearchParams } from "expo-router";

const renderGridItem = (item) => {
    const local = useLocalSearchParams();
    const gender = local?.gender ?? "female";
    return (
        <View key={item.id} style={styles.gridItem}>
            <TouchableOpacity style={styles.imageContainer} onPress={() => {
                window.open(`/product?id=${item?.id}&brand=${item?.brandName}&product=${item?.productName}&gender=${gender}`, "_blank");
        }}>
                <Image source={{ uri: item?.imageUrls[0] }} style={styles.productImage} resizeMode="cover" />

        </TouchableOpacity>
    </View>
    );
};

const renderCarouselItem = ({ item }) => <FavdislikeCardComponent item={item} />;

const ExploreTheLookView = ({ outfitData, setCurrentPageId }) => {
    const local = useLocalSearchParams();
    const gender = local?.gender ?? "female";
    return (
        <View style={styles.container}>
            <View style={styles.gridContainer}>
                {outfitData?.map(renderGridItem)}
                <View style={styles.buttonContainer}>
                    <Buttons
                        containerStyle={styles.btnStyle}
                        isInverse
                        text="Select Products"
                        onPress={() => {
                            setCurrentPageId(2);
                        }}
                    />
                    <Buttons
                        containerStyle={styles.btnStyle}
                        isInverse
                        text="Customize the Look"
                        onPress={() => {
                            setCurrentPageId(4);
                        }}
                    />
                </View>
            </View>
            <View style={styles.carouselContainer}>
                <VText style={styles.carouselTitle} text="Items in this Look" />
                {outfitData?.length > 0 ? (
                    <Carousel
                        loop={false}
                        width={wp(190)}
                        height={hp(373)}
                        style={{ width: "100%", pointerEvents: "auto", cursor: "pointer" }}
                        autoPlay={false}
                        autoPlayInterval={2000}
                        userInteractions={true}
                        data={outfitData}
                        renderItem={renderCarouselItem}
                        keyExtractor={(item, index) => index.toString()}
                    />
                ) : (
                    <VText style={styles.noItemsText} text="No items in this look" />
                )}
            </View>
        </View>
    );
};

export default React.memo(ExploreTheLookView);

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    gridContainer: {
        marginLeft: spH(5),
        width: "100%",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "flex-start",
        gap: spH(5),
    },
    carouselContainer: {
        marginVertical: spV(20),
        marginLeft: spH(5),
        width: "100%",
    },
    carouselTitle: {
        fontSize: fp(24),
        fontWeight: "400",
        marginBottom: spV(10),
    },
    gridItem: {
        width: "32.7%",
    },
    imageContainer: {
        width: "100%",
        aspectRatio: 1,
        height: hp(300),
        borderRadius: fp(8),
        overflow: "hidden",
        position: "relative",
    },
    productImage: {
        width: "100%",
        height: "100%",
    },
    viewSimilarButton: {
        backgroundColor: "#f5f5f5",
        padding: spV(8),
        borderRadius: fp(4),
        alignItems: "center",
        marginBottom: spV(8),
    },
    viewSimilarText: {
        fontSize: fp(12),
        fontWeight: "500",
    },
    brandText: {
        fontSize: fp(14),
        fontWeight: "500",
        marginBottom: spV(4),
    },
    nameText: {
        fontSize: fp(12),
        color: "#666",
        marginBottom: spV(4),
    },
    priceText: {
        fontSize: fp(14),
        fontWeight: "500",
        marginBottom: spV(8),
    },
    shopButton: {
        backgroundColor: "#f5f5f5",
        padding: spV(8),
        borderRadius: fp(4),
        alignItems: "center",
    },
    shopButtonText: {
        fontSize: fp(12),
        fontWeight: "500",
    },
    buttonContainer: {
        flexDirection: "row",
        gap: spV(10),
        marginTop: spV(10),
        width: "100%",
    },
    btnStyle: {
        width: "48%",
        borderWidth: 1,
        borderColor: "#21242729",
        height: hp(40),
    },
});
